import styled from 'styled-components';

import { headerVariables } from '../../components/Header/HeaderStyle';
import { singleReportHeaderVariables } from '../../components/SingleReportHeader/SingleReportHeaderStyle';

import { breakpoints, colors, fontFamily, zIndex } from '../../ui/variables';

export const SingleReportStyle = styled.main`
  box-sizing: border-box;
  min-height: 100vh;
  padding: ${headerVariables.main.height.iphone +
    singleReportHeaderVariables.main.height.iphone}px
    0 0;
  width: 100%;

  @media (min-width: ${breakpoints.ipadLandscape.width}px) {
    padding: ${headerVariables.main.height.iphone +
      singleReportHeaderVariables.main.height.ipadLandscape}px
      0 0;
  }

  &.without-header {
    padding: 32px;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      padding: 32px;
    }
  }

  .snack-bar-wrapper {
    ${zIndex.sky};
    left: 0;
    position: fixed;
    top: ${headerVariables.main.height.iphone +
    singleReportHeaderVariables.main.height.iphone}px;
    width: 100%;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      top: ${headerVariables.main.height.iphone +
      singleReportHeaderVariables.main.height.ipadLandscape}px;
    }
  }

  .report-content-grid {
    @media (min-width: ${breakpoints.ipad.width}px) {
      column-gap: 8px;
      display: grid;
      grid-template-columns: calc(40% - 4px) calc(60% - 4px);
      grid-template-row: auto;
    }

    @media (min-width: ${breakpoints.hd.width}px) {
      grid-template-columns: 380px calc(100% - 404px);
    }

    @media (min-width: ${breakpoints.fullHd.width}px) {
      margin: 0 auto;
      max-width: ${breakpoints.fullHd.width}px;
    }

    .side-bar {
      background-color: ${colors.veryPaleBlue};
      padding: 8px;

      .container {
        padding: 10px;
      }

      .space {
        height: 6px;
      }

      @media (min-width: ${breakpoints.ipad.width}px) {
        padding: 24px 8px;
        display: flex;
        flex-direction: column;
      }

      @media (min-width: ${breakpoints.hd.width}px) {
        padding: 24px 8px 24px 16px;
      }

      .report-details-section {
        margin-bottom: 8px;

        @media (min-width: ${breakpoints.ipad.width}px) {
          margin-bottom: 0;
        }
      }

      .glyph-chart-section {
        @media (min-width: ${breakpoints.ipad.width}px) {
          order: -1;
          margin-bottom: 8px;
        }

        .glyph-chart-section-title {
          display: none;

          @media (min-width: ${breakpoints.ipad.width}px) {
            ${fontFamily.sourceSansPro.bold};
            font-size: 14px;
            line-height: 18px;
            color: ${colors.grayishBlue};
            margin-bottom: 8px;
            display: block;
            padding-left: 20px;
          }
        }
      }
    }

    .report-main-content {
      background-color: ${colors.veryPaleBlue};

      @media (min-width: ${breakpoints.ipad.width}px) {
        background-color: ${colors.white};
        padding: 48px 0 0;
      }

      @media (min-width: ${breakpoints.hd.width}px) {
        column-gap: 16px;
        display: grid;
        grid-template-areas: 'report-image infographic' 'quantitative exam-images' 'histogram histogram';
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto;
      }

      @media (min-width: ${breakpoints.wxgaPlus.width}px) {
        grid-template-areas: 'report-image infographic infographic infographic' 'quantitative exam-images exam-images exam-images' 'histogram histogram histogram histogram';
        grid-template-columns: 1fr 1fr 1fr 1fr;
      }

      &.radiography-content {
        padding: 0;

        @media (min-width: ${breakpoints.hd.width}px) {
          display: block;
        }
      }

      .x-ray-image-gallery {
        background-color: ${colors.black};
        padding: 8px 0;
        width: 100%;

        @media (min-width: ${breakpoints.hd.width}px) {
          display: flex;
        }

        .x-ray-image-item {
          width: 100%;

          @media (min-width: ${breakpoints.hd.width}px) {
            min-width: 50%;
            max-width: 50%;
          }

          .x-ray-image-item-file {
            display: block;
            width: 100%;
            height: auto;
          }
        }
      }

      .report-image-section,
      .quantitative-analysis-section,
      .exam-images-gallery-section,
      .infographic-gallery-section {
        margin-bottom: 8px;
        padding: 0 8px;

        @media (min-width: ${breakpoints.ipad.width}px) {
          padding: 0 8px 0 0;
        }

        @media (min-width: ${breakpoints.hd.width}px) {
          margin-bottom: 16px;
          padding: 0;
        }
      }

      .report-image-section {
        @media (min-width: ${breakpoints.hd.width}px) {
          grid-area: report-image;
        }
      }

      .quantitative-analysis-section {
        @media (min-width: ${breakpoints.hd.width}px) {
          grid-area: quantitative;
        }
      }

      .exam-images-gallery-section {
        @media (min-width: ${breakpoints.hd.width}px) {
          grid-area: exam-images;
        }
      }

      .infographic-gallery-section {
        @media (min-width: ${breakpoints.hd.width}px) {
          grid-area: infographic;
        }
      }

      .histogram-gallery-section {
        padding: 0 8px 64px;

        @media (min-width: ${breakpoints.ipad.width}px) {
          padding: 0;
        }

        @media (min-width: ${breakpoints.hd.width}px) {
          grid-area: histogram;
          padding: 0 0 20px;
        }
      }
    }

    .iframe-study-viewer {
      width: 98vw;
      height: 80vh;
      margin: auto;
    }

    .iframe-title {
      font-size: 60px;
      margin-bottom: 20px;
      line-height: 23px;
      font-family: SourceSansPro;
      font-weight: bold;
      font-style: normal;
      text-align: center;
      color: #303A48;
    }
  }

  .review-modal-content {
    background-color: ${colors.veryPaleBlue};
    padding: 48px 20px 36px;
    width: 100%;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      max-width: 720px;
      padding: 48px 40px 36px;
      width: 100vw;
    }

    .review-modal-title {
      ${fontFamily.sourceSansPro.bold};
      color: ${colors.veryDarkGray};
      font-size: 18px;
      line-height: 20px;
      margin-bottom: 16px;
    }

    .review-modal-description {
      ${fontFamily.sourceSansPro.regular};
      font-size: 14px;
      line-height: 20px;
      color: ${colors.veryDarkGray};
      margin-bottom: 12px;
    }

    .review-modal-justifications {
      margin-bottom: 32px;

      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        display: flex;
      }

      .modal-justification-item {
        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          flex-basis: 50%;
          flex-grow: 1;
        }

        &:nth-child(2n + 1) {
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            margin-right: 8px;
          }
        }

        &:nth-child(2n + 2) {
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            margin-left: 8px;
          }
        }

        &:not(:last-child) {
          margin-bottom: 16px;

          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            margin-bottom: 0;
          }
        }

        .type-item-instruction {
          ${fontFamily.sourceSansPro.regular};
          color: ${colors.grayishBlue};
          font-size: 14px;
          line-height: 20px;
          margin-top: 4px;
        }
      }
    }

    .review-modal-about-desagree {
      margin-bottom: 32px;

      .modal-about-desagree-instruction {
        ${fontFamily.sourceSansPro.regular};
        color: ${colors.veryDarkGray};
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 12px;
      }
    }
  }
`;
